import {
  GridFilterInputValue,
  type GridFilterOperator,
} from "@mui/x-data-grid-premium";
import { NumberFilterModeEnum } from "@exonn/js-sdk";

export const getDataGridNumberFilterOperators = (): GridFilterOperator[] => {
  const normalizeNumber = (value: string | undefined) => {
    if (!value) return "";
    return value.replace(",", ".").trim();
  };
  return [
    {
      value: NumberFilterModeEnum.Between,
      getApplyFilterFn: (filterItem) => {
        return (value) => {
          if (!filterItem.value) {
            return true;
          }
          if (
            typeof filterItem.value === "string" &&
            filterItem.value.includes("bis")
          ) {
            const range = filterItem.value
              .split("bis")
              .map((value) => value.trim());
            if (range[0] != null && range[1] != null) {
              const min = normalizeNumber(range[0]);
              const max = normalizeNumber(range[1]);
              return min <= value && value <= max;
            }
          }
          if (
            typeof filterItem.value === "string" &&
            filterItem.value.includes("to")
          ) {
            const range = filterItem.value
              .split("to")
              .map((value) => value.trim());
            if (range[0] != null && range[1] != null) {
              const min = normalizeNumber(range[0]);
              const max = normalizeNumber(range[1]);
              return min <= value && value <= max;
            }
          }
          return normalizeNumber(filterItem.value) == value;
        };
      },
      label: "",
      headerLabel: "",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: "number" },
    },
  ];
};
